import LoadingPage from "./modules/LoadingPage.vue";
import DefaultPage from "./modules/DefaultPage.vue";
import ConfirmDialog from "./modules/ConfirmDialog.vue";
export { LoadingPage, DefaultPage, ConfirmDialog };

